import styled from 'styled-components';
import { BLACK_1 } from '../../../consts/colors';

export const InfoPagePrivacyParagraph = styled.p`
  position: relative;
  margin-left: 30px;
  margin-bottom: 0;
  &:before {
    content: '';
    position: absolute;
    left: -15px;
    top: 7px;
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${BLACK_1};
  }
`;
